import { useContext } from 'react';
import { ModalsDispatchContext, ModalsStateContext } from './ModalsContext';

const Modals = () => {
  const openedModals = useContext(ModalsStateContext);
  const { close } = useContext(ModalsDispatchContext);

  return (
    <>
      {/* 또는 <> 사용 가능 */}
      {openedModals.map((modal, index) => {
        const { Component, props } = modal;
        const { onSubmit, onCancel, ...restProps } = props;
        const onClose = () => {
          close(Component);
        };

        const handleSubmit = async props => {
          if (typeof onSubmit === 'function') {
            await onSubmit(props);
          }
          onClose();
        };

        const handleCancel = async () => {
          if (typeof onCancel === 'function') {
            await onCancel();
          }
          onClose();
        };

        return (
          <Component
            {...restProps}
            key={index} // 여기서 key를 지정
            onClose={onClose}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
          />
        );
      })}
    </> // 또는 </> 사용 가능
  );
};

export default Modals;
